function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useMemo } from 'react';
import './BaseSchemaForm.scss';
import { injectIntl } from 'react-intl';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import compose from '../../utils/compose';
import { withAdditionalIntl } from '../../I18n/AdditionalIntl/AdditionalIntl';
import en from './locales/BaseSchemaForm.en.json';
import SchemaField from 'react-jsonschema-form/lib/components/fields/SchemaField';
import { getDefaultRegistry } from 'react-jsonschema-form/lib/utils';
import WidgetSizeContext from '../WidgetSizeContext/WidgetSizeContext';
import FormDataContext from '../FormDataContext';
import IndentFieldsContext from '../IndentFieldsContext/IndentFieldsContext';
var localePrefix = '@dm/components.form';
var localePrefixError = '@dm/components.form.errors.';
var messages = normalizeLocaleData(en, localePrefix);
function BaseFieldTemplate(props) {
  return props.children;
}
var defaultTransformErrors = function defaultTransformErrors(transformErrors, intl) {
  return function (errors) {
    var defaultErrors = errors.map(function (error) {
      error.message = intl.formatMessage({
        id: localePrefixError + error.name,
        defaultMessage: error.message
      }, error.params);
      return error;
    });
    return transformErrors ? transformErrors(defaultErrors) : defaultErrors;
  };
};
var BaseSchemaForm = function BaseSchemaForm(props) {
  var ArrayFieldTemplate = props.ArrayFieldTemplate,
    _props$FieldTemplate = props.FieldTemplate,
    FieldTemplate = _props$FieldTemplate === void 0 ? BaseFieldTemplate : _props$FieldTemplate,
    GroupTemplate = props.GroupTemplate,
    ObjectFieldTemplate = props.ObjectFieldTemplate,
    TextTemplate = props.TextTemplate,
    children = props.children,
    component = props.component,
    fields = props.fields,
    formContext = props.formContext,
    formData = props.formData,
    formRef = props.formRef,
    icons = props.icons,
    intl = props.intl,
    _props$indentFields = props.indentFields,
    indentFields = _props$indentFields === void 0 ? false : _props$indentFields,
    onChange = props.onChange,
    onError = props.onError,
    onSubmit = props.onSubmit,
    schema = props.schema,
    transformErrors = props.transformErrors,
    uiSchema = props.uiSchema,
    validate = props.validate,
    view = props.view,
    _props$widgetSize = props.widgetSize,
    widgetSize = _props$widgetSize === void 0 ? 'large' : _props$widgetSize,
    widgets = props.widgets;
  var context = useMemo(function () {
    return _objectSpread({
      TextTemplate: TextTemplate,
      GroupTemplate: GroupTemplate,
      schema: schema,
      uiSchema: uiSchema,
      icons: icons,
      view: view,
      isPrintView: view === 'PRINT',
      isCardView: view === 'CARD'
    }, formContext);
  }, [TextTemplate, GroupTemplate, schema, uiSchema, icons, view, formContext]);
  var registry = useMemo(function () {
    var defaultRegistry = Object.assign({}, getDefaultRegistry());
    defaultRegistry.fields = Object.assign({}, defaultRegistry.fields, fields);
    return _objectSpread({}, defaultRegistry, {
      widgets: widgets,
      FieldTemplate: FieldTemplate,
      ArrayFieldTemplate: ArrayFieldTemplate,
      ObjectFieldTemplate: ObjectFieldTemplate,
      formContext: context
    });
  }, [ArrayFieldTemplate, FieldTemplate, ObjectFieldTemplate, context, fields, widgets]);
  var indentFieldsValue = useMemo(function () {
    return {
      enabled: indentFields,
      level: view === 'CARD' ? 0 : 1
    };
  }, [indentFields, view]);
  var Component = component || SchemaField;
  var handleChange = useCallback(function (state) {
    var formData = state.formData || state;
    onChange(formData);
  }, [onChange]);
  return /*#__PURE__*/React.createElement(WidgetSizeContext.Provider, {
    value: widgetSize
  }, /*#__PURE__*/React.createElement(FormDataContext.Provider, {
    value: formData
  }, /*#__PURE__*/React.createElement(IndentFieldsContext.Provider, {
    value: indentFieldsValue
  }, /*#__PURE__*/React.createElement(Component, {
    ref: formRef,
    ArrayFieldTemplate: ArrayFieldTemplate,
    FieldTemplate: FieldTemplate,
    ObjectFieldTemplate: ObjectFieldTemplate,
    className: "_dm-form",
    fields: fields,
    formContext: context,
    formData: formData,
    idPrefix: "",
    autocomplete: "off",
    noHtml5Validate: true,
    noValidate: false,
    onChange: handleChange,
    onError: onError,
    onSubmit: onSubmit,
    registry: registry,
    schema: schema,
    showErrorList: false,
    transformErrors: defaultTransformErrors(transformErrors, intl),
    uiSchema: uiSchema,
    validate: validate,
    widgets: widgets
  }, children || ' '))));
};
var enhanced = compose(withAdditionalIntl(messages), injectIntl)(BaseSchemaForm);
enhanced.displayName = 'Enhanced(BaseSchemaForm)';
export default enhanced;